import { MouseEvent, RefObject, useEffect } from 'react';

const defaultCheck = <T extends Element>(
  ref: RefObject<T | null>,
  e: MouseEvent
) => ref.current && !ref.current.contains(e.target as Element);

interface UseOutsideClickProps<T> {
  ref: RefObject<T | null>;
  callback: () => void;
  isClickedOutside?: (ref: RefObject<T | null>, e: MouseEvent) => boolean;
  eventType?: 'mousedown' | 'click';
}

export const useOutsideClick = <T extends Element>({
  ref,
  callback,
  isClickedOutside,
  eventType = 'mousedown',
}: UseOutsideClickProps<T>) => {
  const handleClick = (e: MouseEvent) => {
    if (isClickedOutside) {
      if (isClickedOutside(ref, e)) {
        callback();
      }
    } else if (defaultCheck(ref, e)) {
      callback();
    }
  };

  useEffect(() => {
    //@ts-ignore
    document.addEventListener(eventType, handleClick);

    return () => {
      //@ts-ignore
      document.removeEventListener(eventType, handleClick);
    };
  }, [callback]);
};
